import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParsedUrlQuery } from "querystring";
import getChannelConfigByPathName from "src/api/channel";
import AffiliatePage from "src/components/AffiliatePage/AffiliatePage";
import withUserOrGuest from "src/components/Auth/withUserOrGuest";
import { withLayout } from "src/components/Layout/withLayout";
import { withUserProfileLayout } from "src/components/Layout/withUserProfileLayout";
import { AFFILIATE_HEAD_META } from "src/constants/affiliate";
import { LOGICAL_GROUP_CHANNEL_CODE } from "src/constants/logicalGroupChannelCode";
import { checkUnknownError } from "src/utils/errors";

export interface CustomParams extends ParsedUrlQuery {
  channelPath: string;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<CustomParams>
) {
  const channelPath = context.params?.channelPath;
  const { locale } = context;

  try {
    const channelConfig = await getChannelConfigByPathName(channelPath);

    if (!channelConfig) {
      return {
        notFound: true,
      };
    }

    if (channelConfig.logicalGroupChannelCode !== LOGICAL_GROUP_CHANNEL_CODE) {
      return {
        notFound: true,
      };
    }

    const systemChannelCode = channelConfig.code;
    return {
      props: {
        channelPath,
        channelConfig,
        systemChannelCode,
        contentPadding: "0px",
        title: AFFILIATE_HEAD_META.TITLE[locale] || null,
        description: AFFILIATE_HEAD_META.DESCRIPTION[locale] || null,
        image: AFFILIATE_HEAD_META.IMAGE,
        ...(await serverSideTranslations(locale, [
          "login-page",
          "common",
          "cookie-consent",
          "layout",
          "user-profile",
          "form",
          "otp-form",
          "affiliate",
          "cookie-consent",
          "contact",
          "error-dialog",
        ])),
      },
    };
  } catch (error) {
    const isUnknownError = checkUnknownError(error);

    if (!isUnknownError) {
      return {
        redirect: {
          destination: `/${channelPath}`,
        },
      };
    }

    throw error;
  }
}

export default withUserOrGuest(
  withLayout(withUserProfileLayout(AffiliatePage))
);
